// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  APP_VERSION: '1.0.0',
  BASE_URL: 'http://localhost:4200/',
  API_KEY_HEADER:"40y2A5WafUSnL67fuBWH5Na1XSnkEJ97WbZ8qhCc",
  // ── LOCAL DEV (kept for reference, NOT active — see PCI incident note below):
  //    services on localhost with their mounted route prefixes (verified from each routers/routes.js).
  //    Run each backend on the port shown, then `ng serve`, and swap this block back in.
  // BASE_API_URL_METADATA:       "http://localhost:3103/payfills-metadata/v1/",
  // BASE_API_URL_INVOICE:        "http://localhost:3101/payfills-invoice/v1/",
  // BASE_API_URL_AUTHENTICATION: "http://localhost:3100/payfills-auth/v1/",
  // BASE_API_URL_NOTIFICATION:   "http://localhost:3102/payfills-notification/v1/",
  // BASE_API_URL_PAYMENT:        "http://localhost:3104/payfills-payment/v1/",
  // BASE_API_URL_PRODUCT:        "http://localhost:3105/payfils-product/v1/",   // note: "payfils" (single l) is the actual prefix
  // BASE_API_URL_REPORT:         "http://localhost:3106/payfils-report/v1/",    // note: "payfils" (single l)
  // ── Cloud (dev) endpoints — ACTIVE. Restored 2026-09-08 after this block was found
  // pointed at localhost in a build that got deployed to the live merchant.paykanz.com
  // (every API call 404/CORS-failed for real visitors). Do not deploy with the
  // localhost block active — swap it back to this one before any `build-dev` + S3 sync.
  BASE_API_URL_METADATA: "https://ybr26oy3xh.execute-api.eu-central-1.amazonaws.com/dev/metadata/",
  BASE_API_URL_INVOICE: "https://0dusq4k2m6.execute-api.eu-central-1.amazonaws.com/dev/invoice/",
  BASE_API_URL_AUTHENTICATION: "https://3zhdwnxzpd.execute-api.eu-central-1.amazonaws.com/dev/authentication/",
  BASE_API_URL_NOTIFICATION: "https://3gzpeqzplc.execute-api.eu-central-1.amazonaws.com/dev/notification/",
  BASE_API_URL_PAYMENT: "https://8hxq7x9vm2.execute-api.eu-central-1.amazonaws.com/dev/payments-merchant/",
  BASE_API_URL_PRODUCT: "https://tca0di5980.execute-api.eu-central-1.amazonaws.com/dev/product/",
  BASE_API_URL_REPORT: "https://o0ts9u0fd7.execute-api.eu-central-1.amazonaws.com/dev/report/",
  GMAIL_CLIENT_ID:"498134750917-o1b4ct38ckf5e7ao5jebmv3pikq7nl2o.apps.googleusercontent.com",
  // jwt_encryption / password_secret / crypto_private_key removed: insecure client-side crypto eliminated.
  // TODO (VAPT-PKZ-2026-03 #9): replace with the NEW Pusher app's key/cluster.
  // This is still the OLD, compromised app (public `notification_*` channels, anonymously
  // subscribable). PusherService refuses to subscribe while this value is unchanged.
  // NB the app KEY is public by design and safe in the bundle; the app SECRET is
  // server-side only, in AWS Secrets Manager. Only the key belongs here.
  PUSHER_CLIENT_KEY: "afdbffdc480f674d0ee4",
  PUSHER_CLIENT_CLUSTER: "ap2",
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
